import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Location as ILocation } from '../models/location';

export const locationEntityAdapter: EntityAdapter<ILocation> = createEntityAdapter<ILocation>();
